module.exports = __webpack_public_path__ + "ky.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ky.svg
// module id = 904
// module chunks = 0